module.exports = __webpack_public_path__ + "img/avatar.1d9e034d.png";